export const setAppVersion = version => {
  return {
    type: 'APP_VERSION',
    payload: version
  }
}

export const setAppTheme = data => {
  return {
    type: 'APP_THEME',
    payload: data
  }
}

export const setAppLoading = state => {
  return {
    type: 'APP_LOADING',
    payload: state
  }
}

export const resetApp = () => {
  return {
    type: 'APP_RESET'
  }
}

export const setOnline = online => {
  return {
    type: 'APP_ONLINE',
    payload: online
  }
}
